import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Game } from "./features/game/pages";
import {
  Home,
  Login,
  Loading,
  Scene,
  Storyboard,
  Mode,
} from "./features/login/pages";
import Leaderboard from "./features/game/components/Leaderboard";

function Routes() {
  return (
    <div>
      <BrowserRouter>
        <Switch>
          <Route path="/game" exact>
            <Game />
          </Route>
          <Route path="/game/:id/:name" exact>
            <Game />
          </Route>
          <Route path="/login" exact>
            <Login />
          </Route>
          <Route path="/mode" exact>
            <Mode />
          </Route>
          <Route path="/leaderboard" exact>
            <Leaderboard />
          </Route>
          <Route path="/scene" exact>
            <Scene />
          </Route>
          <Route path="/mahabharat-story" exact>
            <Storyboard />
          </Route>
          <Route path="/loading/:roomId" exact>
            <Loading />
          </Route>
          <Route path="/" exact>
            <Home />
          </Route>
          {/* <Route path="/login" exact>
            <Login loginType="LOGIN" />
          </Route>
          <Route path="/signup" exact>
            <Login loginType="SIGNUP" />
          </Route>
          <Route path="/profile" exact>
            {isAuthenticated() ? <Profile /> : <Login loginType="LOGIN" />}
          </Route>
          <Route path="/">
            {isAuthenticated() ? <Home /> : <LandingPage />}
          </Route> */}
        </Switch>
      </BrowserRouter>
      {/* <h1>Routes</h1> */}
    </div>
  );
}

export default Routes;
